<app-ol-main #map 
[location]="location" 
[showCardTitle]="false" 
[showButtonLayers]="true"
[mapWidth]="mapWidth" 
[mapHeight]="mapHeight"
[options]="options"

></app-ol-main>